<template>

  <Head title="Login" />
  <div class="hold-transition login-page">
    <div class="login-box">
      <div class="card card-outline card-primary">
        <div class="card-header text-center">
          <a href="#" class="h1">
            <b>KUNJUNGAN</b>
          </a>
        </div>
        <div class="card-body">
          <p class="login-box-msg">Masuk untuk memulai sesi Anda</p>
          <form @submit.prevent="submit">
            <input-group placeholder="Email" class="fas fa-envelope" v-model="form.email" :error="form.errors.email" />
            <input-group placeholder="Sandi" class="fas fa-lock" v-model="form.password" :error="form.errors.password"
              type="password" />
            <div class="row">
              <div class="col-8">
                <div class="icheck-primary">
                  <input type="checkbox" id="remember" v-model="form.remember" />
                  <label for="remember">
                    Ingat saya
                  </label>
                </div>
              </div>

              <div class="col-4">
                <button type="submit" class="btn btn-primary btn-block" :disabled="form.processing">
                  Masuk
                </button>
              </div>
            </div>
          </form>

          <p class="mb-1">
            <a href="/forgot-password">Saya lupa kata sandi saya</a>
          </p>
          <p class="mb-0">
            <a href="/register" class="text-center">
              Daftarkan keanggotaan baru
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import InputGroup from '@/Forms/InputGroup'

export default {
  components: {
    Head,
    InputGroup,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: null,
        password: null,
        remember: false,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/login', {
        preserveScroll: true,
        onSuccess: (page) => {
          window.location.reload()
        },
      })
    },
  },
}
</script>

<style>
.login-page {
  /* The image used */
  /* background-image: url("/background.jpg"); */
  background: rgba(0, 0, 0, .65) url("/default/background.jpg");
  background-blend-mode: darken;

  /* Control the height of the image */
  min-height: 380px;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
